/**
 * FairwayBid – die Argumente für beide Seiten
 *
 * Auf der Startseite stand bisher, WAS FairwayBid ist. Was ein Besucher in
 * den ersten Sekunden sucht, ist aber etwas anderes: Was habe ich davon?
 * Und die Antwort ist für eine Golfanlage eine ganz andere als für einen
 * Händler – deshalb stehen hier zwei Argumentationen nebeneinander statt
 * einer gemeinsamen.
 *
 * Die Texte stehen bewusst hier und nicht in der Console: Sie gehören zur
 * Gestaltung des Abschnitts (Anzahl der Punkte, Länge der Zeilen). Wer sie
 * ändern will, ändert sie hier – eine Datei, klar benannt.
 */

/** Abschnitt mit dem Ablauf in Schritten. */
export const STEPS_SECTION_IDS = ['public-ablauf', 'public-schritte'];
export const STEPS_TYPE = 'fwb-schritte';
export const isStepsSection = section => STEPS_SECTION_IDS.includes(section?.sectionId || '');

/** Abschnitte der Startseite, die diesen Baustein bekommen. */
export const BENEFIT_SECTION_IDS = ['public-warum', 'public-vorteile'];
export const BENEFIT_TYPE = 'fwb-vorteile';

export const isBenefitSection = section => BENEFIT_SECTION_IDS.includes(section?.sectionId || '');

export const BENEFITS = [
  {
    key: 'club',
    eyebrow: 'Für Golfanlagen',
    headline: 'Nie wieder hinterhertelefonieren.',
    lead:
      'Bedarf einmal beschreiben – die passenden Händler antworten mit konkreten Angeboten. Sie vergleichen, Sie entscheiden.',
    points: [
      'Kein Herumtelefonieren, kein Nachhaken bei fünf Anbietern',
      'Alle Angebote in derselben Struktur: Preis, Lieferzeit, Garantie, Montage',
      'Vorstandssitzung: eine Vergleichstabelle statt sechs E-Mail-Anhänge',
      'Vergabevermerk auf Knopfdruck – für Vorstand, Kämmerer und Prüfung',
      'Dauerhaft kostenlos, unverbindlich, ohne Mindestlaufzeit',
    ],
    ctaLabel: 'Als Golfanlage registrieren',
  },
  {
    key: 'dealer',
    eyebrow: 'Für Händler und Hersteller',
    headline: 'Kunden, die schon wissen, was sie brauchen.',
    lead:
      'Keine Kaltakquise. Die Golfanlage stellt ihren Bedarf ein – Sie antworten mit einem Angebot. Einfacher wird Vertrieb nicht.',
    points: [
      'Kein Kaltakquise-Telefonat – der Bedarf liegt schon auf dem Tisch',
      'Kategorien und Lieferländer angeben – Sie sehen genau die passenden Anfragen aus DE, AT, CH, NL und FR',
      'Anfrage rein, Angebot raus – mehr Schritte gibt es nicht',
      'Mit höherem Tarif sehen Sie neue Anfragen vor allen anderen',
      'Markteintritt USA ab Mitte 2027',
    ],
    ctaLabel: 'Als Händler registrieren',
  },
];

/**
 * Das Zahlenband über den beiden Karten.
 *
 * WICHTIG, bitte beim Ändern lesen: Die 340 Golfanlagen und die über 30
 * Händler sind Vormerkungen für den Start, keine aktiven Konten im Portal.
 * Genau so steht es auch da. Wer daraus „registriert" macht, behauptet
 * etwas, das ein Besucher nach der Anmeldung nicht wiederfindet – und ein
 * Investor prüft solche Zahlen.
 */
export const PROOF_POINTS = [
  { value: '340', label: 'Golfanlagen', note: 'für den Start vorgemerkt' },
  { value: 'über 30', label: 'Händler und Hersteller', note: 'für den Start vorgemerkt' },
  { value: '5', label: 'Märkte in Europa', note: 'DE · AT · CH · NL · FR' },
  { value: 'Mitte 2027', label: 'Markteintritt USA', note: 'in Vorbereitung' },
];

/**
 * Steht unter beiden Karten. Hier stand vorher ein Link auf eine eigene Seite
 * ("Was wir vor der Freischaltung prüfen"). Der Satz sagt jetzt selbst, was
 * geprüft wird – das ist kürzer als ein Klick und beantwortet die Frage an
 * der Stelle, an der sie entsteht.
 */
export const TRUST_NOTE =
  'Registrierung in zwei Minuten. Bei Händlern und Herstellern prüfen wir danach einmalig Handelsregister und USt-IdNr. und schalten das Konto frei – keine anonymen Angebote, keine Massen-Mails.';
